"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const dialog_style_1 = __importDefault(require("./dialog.style"));
class Dialog extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { open, onOverlayClick, classes, children } = this.props;
            if (!open)
                return null;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.container, "data-cy": "atomic-dialog" }, { children: [jsx_runtime_1.jsx("div", { className: classes.overlay, onClick: onOverlayClick }, void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ className: classes.prompt }, { children: children }), void 0)] }), void 0));
        };
    }
}
exports.Dialog = Dialog;
Dialog.propTypes = {
    open: prop_types_1.default.bool.isRequired,
    children: prop_types_1.default.node.isRequired,
    onOverlayClick: prop_types_1.default.func.isRequired,
    classes: prop_types_1.default.object.isRequired
};
exports.default = react_jss_1.default(dialog_style_1.default)(Dialog);
//# sourceMappingURL=index.js.map